export const SIGNUP = 'signup';
export const SIGNIN = 'signin';
